import { DownloadSvg, RightSvg } from "@/assets/icons";
import styles from "./index.module.scss";
import { useTranslation } from "react-i18next";
import { ReactEventHandler, useEffect, useRef, useState } from "react";
import { useCommonStore } from "@/stores";
import { CollectButton, PlayerController, PostButton } from "@/components";
import { download, getFileName, getOffset, videoUrl2blobUrl } from "@/utils";
import clsx from "clsx";

const ResultMobile = () => {
  const { t } = useTranslation();
  const mediaEleRef = useRef<HTMLDivElement>(null);
  const videoEleRef = useRef<HTMLVideoElement>(null);
  const wasPlayedRef = useRef(false);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [isCompare, setIsCompare] = useState(false);
  const [position, setPosition] = useState({ left: 0, right: 0, top: 0, bottom: 0 });
  const [controllerVisible, setControllerVisible] = useState(false);
  const [isPlay, setIsPlay] = useState(false);
  const [videoBlobUrl, setVideoBlobUrl] = useState("");
  const task = useCommonStore(state => state.task);
  const sourceImgBlobUrl = useCommonStore(state => state.sourceImgBlobUrl);
  const setTask = useCommonStore(state => state.setTask);

  const play = () => {
    videoEleRef.current?.play();
  }

  const pause = () => {
    videoEleRef.current?.pause();
  }

  const calcPosition = () => {
    const videoEle = videoEleRef.current;
    const mediaEle = mediaEleRef.current;
    if (videoEle && mediaEle) {
      const offset = getOffset(videoEle, mediaEle);
      setPosition(offset);
    }
  }

  const handleLoadedMetadata: ReactEventHandler<HTMLVideoElement> = (e) => {
    setDuration((e.target as HTMLVideoElement).duration);
  }

  const handleLoadedData = () => {
    calcPosition();
    setControllerVisible(true);
  }

  const handleTimeUpdate: ReactEventHandler<HTMLVideoElement> = (e) => {
    setCurrentTime((e.target as HTMLVideoElement).currentTime);
  };

  const handlePlay = () => {
    setIsPlay(true);
    play();
  }

  const handlePause = () => {
    setIsPlay(false);
    pause();
  }

  const handleDownload = () => {
    download(task!.videoPath, getFileName(task!.videoPath));
  }

  const createNew = () => {
    setTask(null);
  }

  useEffect(() => {
    (async () => {
      if (task?.videoPath) {
        try {
          const blobUrl = await videoUrl2blobUrl(task.videoPath);
          setVideoBlobUrl(blobUrl);
        } catch (err) {
          console.error(err);
        }
      }
    })()
  }, [task?.videoPath]);

  useEffect(() => {
		const visibilitychange = () => {
			if (document.visibilityState === 'visible') {
				// todo
			} else {
				handlePause();
			}
		}
		document.addEventListener('visibilitychange', visibilitychange);

		return () => {
			document.removeEventListener('visibilitychange', visibilitychange);
		}
	}, []);

  useEffect(() => {
    return () => {
      if (videoBlobUrl) {
        URL.revokeObjectURL(videoBlobUrl);
      }
    }
  }, [videoBlobUrl])

  return (
    <div
      className={styles["result_mobile"]}
    >
      <div
        className={styles["header"]}
      >
        <button
          className={styles["back_button"]}
          onClick={createNew}
        >
          <RightSvg></RightSvg>
          <span>{t("back_button")}</span>
        </button>

        <div
          className={styles["operation_wrap"]}
        >
          <CollectButton></CollectButton>
        </div>
      </div>

      <div
        ref={mediaEleRef}
        className={styles["media_wrapper"]}
      >
        {videoBlobUrl ? (
          <video 
            ref={videoEleRef}
            className={styles["result_video"]}
            src={videoBlobUrl}
            loop
            playsInline
            autoPlay
            onLoadedMetadata={handleLoadedMetadata}
            onLoadedData={handleLoadedData}
            onTimeUpdate={handleTimeUpdate} // 获取 currentTime
            onContextMenu={e => e.preventDefault()}
            onPlay={() => {
              if (!wasPlayedRef.current) {
                setIsPlay(true);
              }
              wasPlayedRef.current = true;
            }}
          ></video>
        ) : (
          <div
            className={clsx(
              styles["skeleton"],
              "skeleton_loading"
            )}
          ></div>
        )}

        {isCompare && (
          <div
            style={{
              left: position.left,
              right: position.right,
              top: position.top,
              bottom: position.bottom,
            }}
            className={styles["img_wrapper"]}
          >
            <img 
              className={styles["source_img"]}
              src={sourceImgBlobUrl}
              alt="" 
            />
          </div>
        )}

        {controllerVisible && (
          <PlayerController
            style={{
              bottom: position.bottom
            }}
            className={styles["custom_player_controller"]}
            isMobile
            duration={duration}
            currentTime={currentTime}
            isPlay={isPlay}
            compareVisible
            onPlay={handlePlay}
            onPause={handlePause}
            onCompare={() => setIsCompare(true)}
            onCancelCompare={() => setIsCompare(false)}
          ></PlayerController>
        )}
      </div>
      
      <div
        className={styles["operation_row"]}
      >
        <button
          className={styles["download_button"]}
          onClick={handleDownload}
        >
          <DownloadSvg></DownloadSvg>
          <span
            className="ellipsis"
          >
            {t("download_button")}
          </span>
        </button>

        <PostButton
          className={styles["custom_post_button"]}
        ></PostButton>
      </div>
    </div>
  )
}

export default ResultMobile;